import React from "react";
import styles from "./Settings.module.scss";
import { Breadcrumbs, Breadcrumb } from "@blueprintjs/core";

export default function SettingsBreadcrumb({ children, items }) {
  return (
    <div className={styles.settingsBreadcrumbs}>
      <Breadcrumbs
        items={items}
        currentBreadcrumbRenderer={({ text, ...restProps }) => (
          <Breadcrumb className={styles.breadcrumb} {...restProps}>
            {text}
          </Breadcrumb>
        )}
      />
    </div>
  );
}
